import * as React from 'react'

export const SectionBody = ({ children }: { children: React.ReactNode }) => (
  <div className="section-component-body">
    <div className="section-component-body-div">{children}</div>
  </div>
)
